/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import React from "react";
import styled from "styled-components";
import Icon from "../ui/Icon";

const StyledCalendarViewToggle = styled.div`
  text-align: center;
`;

const CalenderViewToggle = styled.span`
  display: inline-flex;
  padding: 6px 16px;
  cursor: pointer;
`;

const CalendarViewToggleIcon = styled((props) => <Icon.ChevronUp {...props} />)`
  stroke: rgba(${({ theme }) => theme.colors.text.rgba});
  transition: transform 0.3 ease;

  ${(props) => props.$isWeekView && `transform: rotate(180deg);`}
`;

const CalendarViewToggle = ({ isWeekView, setIsWeekView }) => {
  const toggleView = () => setIsWeekView((prev) => !prev);

  return (
    <StyledCalendarViewToggle>
      <CalenderViewToggle onClick={toggleView}>
        <CalendarViewToggleIcon size={Icon.SIZE.SM} $isWeekView={isWeekView} />
      </CalenderViewToggle>
    </StyledCalendarViewToggle>
  );
};

export default CalendarViewToggle;
